import { IProductState } from './types';

// RICORDARSI DI AGGIORNARE SE BACKEND CAMBIA
export const ProductWarehouseStatus = {
  ACTIVE: 1,
  DECOMMISSIONED: 2,
  TO_BE_DECOMMISSIONED: 3,
  TENDER: 4
  // BLOCKED: 5
};

export const ProductWarehouseHistorySource = {
  laboratory: 'laboratory',
  operationalunit: 'operationalunit',
  sector: 'sector',
  workstation: 'workstation',
  exam: 'exam'
};

export const productInitialState: IProductState = {
  id: null,
  code: '',
  description: '',
  type: null,
  category: null,
  status: '',
  expiration_alert_threshold: 0,
  preservation_temperature: 0.0,
  locations: []
};
